import React from "react";
import FullWidthHalfHeight from "./configurations/FullWidthHalfHeight";
import FullWidthThirdHeight from "./configurations/FullWidthThirdHeight";
import HalfWidthHalfHeight from "./configurations/HalfWidthHalfHeight";
import HalfWidthThirdHeight from "./configurations/HalfWidthThirdHeight";
import { HeightRestriction, WidthRestriction } from "../../../../../interfaces/Restrictions";
import { Ring } from "@uiball/loaders";
import EmptyContainer from "../../../../containers/EmptyContainer";
import StatsPreview from "../../../../../interfaces/StatsPreview";
import NoDataAvailable from "@appsinti/ui-core/NoDataAvailable";

const PreviewSection: React.FC<{
  preview: StatsPreview | null;
  loading: boolean;
  heightRestriction: HeightRestriction;
  widthRestriction: WidthRestriction;
}> = ({ preview, loading, heightRestriction, widthRestriction }) => {
  if (loading && !preview) {
    return (
      <EmptyContainer>
        <Ring color={"white"} size={30} />
      </EmptyContainer>
    );
  }

  if (!preview) {
    return (
      <NoDataAvailable />
    );
  }

  switch (widthRestriction) {
    case "full-width":
      if (heightRestriction === "half")
        return <FullWidthHalfHeight preview={preview} />;
      if (heightRestriction === "third")
        return <FullWidthThirdHeight preview={preview} />;
      return null;
    case "half-width":
      if (heightRestriction === "half")
        return <HalfWidthHalfHeight preview={preview} />;
      if (heightRestriction === "third")
        return <HalfWidthThirdHeight preview={preview} />;
      return null;
    default:
      return null;
  }
};

export default PreviewSection;
